<template>
  <v-col cols="12">
    <v-form ref="userForm">
        <v-container>
        <v-row>
            <v-col :cols="cols">
            <v-text-field v-model="user.FirstName" :rules="nameRules" :counter="3" label="First name" required></v-text-field>
            </v-col>

            <v-col :cols="cols">
            <v-text-field v-model="user.LastName" :rules="nameRules" :counter="3" label="Last name" required></v-text-field>
            </v-col>

            <v-col :cols="cols">
            <v-text-field v-model="user.Company" :rules="nameRules" :counter="3" label="Company" required></v-text-field>
            </v-col>

            <v-col :cols="cols" >
            <v-text-field v-model="user.Email" :rules="emailRules" label="E-mail" required></v-text-field>
            </v-col>

            <v-col :cols="cols" >
            <v-text-field v-model="user.Password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :rules="[passRules.required, passRules.min]" :type="showPassword ? 'text' : 'password'"
            name="password" label="Password" hint="At least 8 characters" counter @click:append="showPassword = !showPassword"></v-text-field>
            </v-col>
            <v-col :cols="cols" >
            <v-text-field v-model="user.PasswordRe" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :rules="[passRules.required, passRules.min]" :type="showPassword ? 'text' : 'password'"
            name="password" label="Re-Password" hint="At least 8 characters" counter @click:append="showPassword = !showPassword"></v-text-field>
            </v-col>
        </v-row>
        <v-row align="center" justify="center">
           <v-col cols="2" >
                <v-btn v-if="type === 'new'" @click="clickRegister">Register</v-btn>
                <v-btn v-if="type === 'edit'" @click="clickUpdate">Update</v-btn>
            </v-col>
            <v-col cols="8" >
                <v-btn @click="clickCancel">Cancel</v-btn>
            </v-col>
        </v-row>
        </v-container>
    </v-form>
  </v-col>
</template>

<script>

import Models from '@/Models'

export default {
  name: 'User',
  props: ['type'],
  data () {
    return {
      cols: '6',
      showPassword: false,
      user: {
        FirstName: '',
        LastName: '',
        Password: '',
        PasswordRe: '',
        Email: '',
        Company: ''
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length >= 3 || 'Name must be less than 4 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      passRules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match')
      }
    }
  },
  methods: {
    clickCancel (ev) {
      this.$emit('onCancel', Models.VIEW_BATCH_SCAN)
    },
    clickRegister (ev) {
      this.$emit('onRegisterUser', Models.VIEW_BATCH_SCAN, this.user)
    },
    clickUpdate (ev) {
      this.$emit('onUpdateUser', Models.VIEW_BATCH_SCAN, this.user)
    }
  }
}
</script>
